import React from "react";

interface ArrowsIconProps {
  fill?: string;
  onClick?: () => void;
  width?: string;
  height?: string;
}

const Loans: React.FC<ArrowsIconProps> = (props) => {
  return (
    <svg
      width={props.width ?? "24"}
      height={props.height ?? "25"}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onClick}
    >
      <path
        d="M12 17.79C12 20.5515 14.2386 22.79 17 22.79C19.7614 22.79 22 20.5515 22 17.79C22 15.0286 19.7614 12.79 17 12.79C14.2386 12.79 12 15.0286 12 17.79ZM12 17.79C12 16.6642 12.3721 15.6253 13 14.7896V5.79004M12 17.79C12 18.6154 12.2 19.394 12.5541 20.0802C11.7117 20.7918 9.76584 21.29 7.5 21.29C4.46243 21.29 2 20.3946 2 19.29V5.79004M13 5.79004C13 6.89461 10.5376 7.79004 7.5 7.79004C4.46243 7.79004 2 6.89461 2 5.79004M13 5.79004C13 4.68547 10.5376 3.79004 7.5 3.79004C4.46243 3.79004 2 4.68547 2 5.79004M2 14.79C2 15.8946 4.46243 16.79 7.5 16.79C9.689 16.79 11.5793 16.325 12.4646 15.6518M13 10.29C13 11.3946 10.5376 12.29 7.5 12.29C4.46243 12.29 2 11.3946 2 10.29"
        stroke={props.fill || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Loans;
